import * as React from 'react';
import { style } from 'typestyle';
import { ContentSliceProps } from './ContentSlice';
import { BaseTilesSlice } from './BaseTilesSlice';
import { GridTileList } from '../../atoms/GridTileList';
import { GridTileListItem, GridTileListItemProps } from '../../atoms/GridTileListItem';
import { heading4 } from '../../utilities/font';
import { spacing } from '../../../../theme/spacing';

const styles = {
  heading: style(heading4, { margin: `0 0 ${spacing.DEFAULT}` }),
};

type LinkTilesSliceProps = ContentSliceProps & { heading?: string; links: GridTileListItemProps[] };

export const LinkTilesSlice: React.SFC<LinkTilesSliceProps> = ({ heading, links, ...props }) => (
  <BaseTilesSlice {...props}>
    {heading && <h3 className={styles.heading}>{heading}</h3>}
    <GridTileList>
      {links.map((link, key) => (
        <GridTileListItem key={key} {...link} />
      ))}
    </GridTileList>
  </BaseTilesSlice>
);
